export default __webpack_public_path__ + "static/seo-banner-e5db903ecbda86434a175775377addbf.png";